module.exports = __webpack_public_path__ + "kazakhstan.svg?e3cd3d055351f1c49b4e408f09e3460c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/kazakhstan.svg
// module id = 203
// module chunks = 10